module.exports = __webpack_public_path__ + "media/honey-icons/icon-close-6ce4fe62.svg";